import { forEach, findIndex, sum } from 'lodash';
import { ChartData, TableData } from '@scholastic/volume-react';

export const transformTableData = (inputData: ChartData | undefined): TableData => {
  const outputObjNew: TableData = {
    columns: [],
    rows: [],
  };

  const intl = new Intl.NumberFormat();
  if (inputData) {
    forEach(inputData, function (inputObj) {
      outputObjNew.columns.push(inputObj.label);
      Object.entries(inputObj.dataset).map((data) => {
        var existingIndex = findIndex(outputObjNew.rows, function (o: { name: string }) {
          return o.name === data[1].name;
        });

        if (existingIndex > -1) {
          outputObjNew.rows[existingIndex].values.push(intl.format(data[1].value));
        } else {
          var obj = {
            name: data[1].name,
            values: [intl.format(data[1].value)],
          };
          outputObjNew.rows.push(obj);
        }
        return {};
      });
    });

    outputObjNew.columns.push('Total');

    forEach(outputObjNew.rows, (row) => {
      let total = sum(row.values.map((value) => parseInt(value.toString().replace(/,/g, ''))));
      row.values.push(intl.format(total));
    });
  }

  return outputObjNew;
};
